import { render } from "./ProsesDataEmon.vue?vue&type=template&id=64f2cfd8"
import script from "./ProsesDataEmon.vue?vue&type=script&lang=js"
export * from "./ProsesDataEmon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__